import {
    Container,
    StyledIconButton,
} from "app/pages/digital-suite/home-page/components/Rewards/ModalControls/ModalControls.styled";

interface ModalControlsProps {
    onCloseModal: () => void;
}

const ModalControls = ({ onCloseModal }: ModalControlsProps) => (
    <Container>
        <StyledIconButton
            iconName="clear"
            iconSize="sm"
            type="flat"
            onClick={onCloseModal}
        />
    </Container>
);

export default ModalControls;
